import { styled } from "@mui/material"
export const MainContainer = styled("div")(({ theme }) => ({
    [theme.breakpoints.down("sm")]: {
        paddingBottom: "90px",
    },
    [theme.breakpoints.down("md")]: {
        paddingBottom: "90px",
    },
}))
